import React from 'react';
import { useLocation, useNavigate } from 'react-router';

export default function useHistory() {
  const location = useLocation();
  const currentHistory: string[] = React.useMemo(() => location.state?.history, [location.state]);
  const navigate = useNavigate();

  return React.useMemo(() => ({
    hasHistory: !!currentHistory?.length,
    subNavigation(path: string) {
      navigate(path, { state: { history: currentHistory } });
    },
    currentHistoryState: { history: currentHistory ?? [] },
    newHistoryState: { history: [location.pathname, ...(currentHistory ?? [])] },
    goBack() {
      const [previous, ...history] = currentHistory;
      navigate(previous, { state: { history } });
    },
  }), [currentHistory, location.pathname]);
}
